import { render, staticRenderFns } from "./LayoutGradient.vue?vue&type=template&id=b56ff0aa&scoped=true&"
import script from "./LayoutGradient.vue?vue&type=script&lang=js&"
export * from "./LayoutGradient.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGradient.vue?vue&type=style&index=0&id=b56ff0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56ff0aa",
  null
  
)

export default component.exports